import axios from "axios";
import { $observable, bodyHeader } from "../../common/libs/AxiosObservable";

export const getUserInfo = () => {
  return $observable(axios.get("/api/v1/admin/users/user-info"));
};

export const getUsers = () => {
  return $observable(axios.get("/api/v1/admin/users"));
};

export const getUser = ({ id }) => {
  return $observable(axios.get(`/api/v1/admin/users/${id}`));
};

export const deleteUser = ({ id }) => {
  return $observable(axios.delete(`/api/v1/admin/users/${id}`));
};

export const modifyUser = (obj) => {
  return $observable(
    axios.patch(
      `api/v1/admin/users`,
      JSON.stringify({
        ...obj,
        roles: [obj?.role ?? ""],
      }),
      {
        headers: bodyHeader,
      }
    )
  );
};

export const addUser = (obj) => {
  return $observable(
    axios.post(
      `api/v1/admin/users/register`,
      JSON.stringify({
        ...obj,
        roles: [obj?.role ?? ""],
      }),
      {
        headers: bodyHeader,
      }
    )
  );
};
